import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

import Templete from "../Templete/Templete";

import AuthService from "../../../services/User/AuthService";
import ProfileService from "../../../services/User/ProfileService";
import RechargeService from "../../../services/User/RechargeService";
import WalletService from "../../../services/User/WalletService";
import CompanyService from "../../../services/User/CompanyService";
import NoticeService from "../../../services/User/NoticeService";
import HttpError from "../../../utill/HttpError";
import LoadingContext from "../../../store/loading-context";
import NoticeDialog from "./NoticeDialog";

import "./style.css";

const Dashboard = () => {
  const history = useHistory();

  const loadingCtx = useContext(LoadingContext);

  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));

  const [sessionUserType, setSessionUserType] = useState();
  const [name, setName] = useState();
  const [userId, setUserId] = useState();
  const [mobile, setMobile] = useState();

  useEffect(() => {
    getUserType();
    // window.location.reload();
    // fetchAllNotice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getUserType = () => {
    const _userType = AuthService.getUserType();
    const _name = AuthService.getName();
    const _userId = AuthService.getUserID();
    const _mobile = AuthService.getMobile();

    setName(_name);
    setUserId(_userId);
    setMobile(_mobile);
    setSessionUserType(_userType);
  };

  // const [open, setOpen] = useState(false);
  // const [noticeData, setNoticeData] = useState([]);

  // const handleClose = () => {
  //   setOpen(false);
  // };

  // const handleOpen = () => {
  //   setOpen(true);
  // };

  // const fetchAllNotice = async () => {
  //   loadingCtx.startLoading();

  //   try {
  //     const token = AuthService.getAccessToken();

  //     const responseData = await NoticeService.fetchAll(token);
  //     const status = responseData.status;
  //     const message = responseData.message;

  //     if (status === "SUCCESS") {
  //       const data = responseData.data;
  //       setNoticeData(responseData.data);

  //       if (data.length > 0) {
  //         setOpen(true);
  //       }
  //     } else {
  //       Swal.fire("Opps!", message, "error");
  //     }
  //   } catch (error) {
  //     const errMsg = HttpError.getError(error);
  //     Swal.fire("Opps!", errMsg, "error");
  //   }
  //   loadingCtx.stopLoading();
  // };

  const [data, setData] = useState();
  const [resellerData, setResellerData] = useState(false);

  useEffect(() => {
    getTotalBalance();
    resellerUsersTotalBalance();
    getRechargeSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTotalBalance = async () => {
    const _userType = AuthService.getUserType();

    if (_userType == "Reseller") {
      return;
    }

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await ProfileService.totalBalance(token);
      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setData(responseData.data);
      } else {
        if (message === "Unauthorized Access") {
          AuthService.logout();
          window.location.href = "/#/login";
        }
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const resellerUsersTotalBalance = async () => {
    const _userType = AuthService.getUserType();

    if (_userType !== "Reseller") {
      return;
    }

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await WalletService.resellerUsersTotalBalance(token);
      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setResellerData(responseData.data);
      } else {
        if (message === "Unauthorized Access") {
          AuthService.logout();
          window.location.href = "/#/login";
        }
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const [isLoading, setIsloading] = useState(false);

  const [rechargeSummaryData, setRechargeSummaryData] = useState();

  const getRechargeSummary = async (days = null) => {
    setIsloading(true);

    try {
      const token = AuthService.getAccessToken();

      const responseData = await RechargeService.summary(
        token,
        fromDate,
        toDate,
        null,
        null,
        null
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setRechargeSummaryData(responseData.data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    setIsloading(false);
  };

  const [company, setCompany] = useState();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    // loadingCtx.startLoading();

    try {
      const responseData = await CompanyService.fetchByDomainName(
        window.location.hostname
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        const data = responseData.data;
        setCompany(data);
        localStorage.setItem("company", JSON.stringify(data));

        // TITLE
        document.title = data.title_text;

        // FAVICON
        const favicon = document.getElementById("favicon");
        favicon.href = data.favicon;
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    // loadingCtx.stopLoading();
  };

  return (
    <React.Fragment>
      <Templete t1="Home" t2="Dashboard">
        <section class="content">
          <div class="container-fluid">
            {data && (
              <div>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card cstm-bg-dark">
                      <div class="card-header">
                        <h3
                          class="card-title text-center"
                          // style={{ fontSize: "20px", fontWeight: "600" }}
                        >
                          Main Account
                        </h3>
                        <span
                          className="float-right"
                          // style={{ fontSize: "20px", fontWeight: "bold" }}
                        >
                          {company && (
                            <img
                              src={company.favicon}
                              alt="logo"
                              width="27px"
                            />
                          )}
                          {/* {data ? "₹" + data.main_wallet : "..."} */}
                        </span>
                      </div>
                      <div
                        class="card-body"
                        style={{ padding: "15px 15px 5px 15px" }}
                      >
                        <div class="row">
                          <div class="col-6">
                            <h6>Available Balance</h6>
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                color: "green",
                              }}
                            >
                              {data ? "₹" + data.main_wallet : "..."}
                              <i
                                onClick={getTotalBalance}
                                class="fas fa-redo"
                                style={{
                                  paddingLeft: "10px",
                                  fontSize: "15px",
                                }}
                              ></i>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div className="">
                              <a
                                class="btn btn-app"
                                onClick={() => {
                                  history.push("/user/add_money");
                                }}
                              >
                                <i class="fas fa-rupee-sign"></i> Add Money
                              </a>

                              <a
                                class="btn btn-app"
                                onClick={() => {
                                  history.push("/user/wallet_statement");
                                }}
                              >
                                <i class="fas fa-wallet"></i> Statement
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4 col-6">
                    <div class="small-box card">
                      <div class="inner">
                        <h5>
                          ₹
                          {data
                            ? data.today_wallet_topup[0]["total_amount"]
                            : ""}
                        </h5>
                        <p>Today Wallet Topup</p>
                      </div>
                      <div class="icon">
                        <i class="fas fa-wallet"></i>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4 col-6">
                    <div class="small-box card">
                      <div class="inner">
                        <h5>
                          ₹{data ? data.today_earning[0]["total_amount"] : ""}
                        </h5>
                        <p>Today Earning</p>
                      </div>
                      <div class="icon">
                        <i class="fas fa-rupee-sign"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {resellerData && (
              <div className="row">
                <div class="col-lg-2 col-6">
                  <div class="small-box bg-info">
                    <div class="inner">
                      <h4>
                        <b>
                          ₹{resellerData ? resellerData.my_main_wallet : "0"}
                        </b>
                      </h4>
                      <p>Wallet Balance</p>
                    </div>
                    <div class="icon">
                      <i class="ion ion-bag"></i>
                    </div>
                    <a
                      href="/#/user/total_wallet_balance"
                      class="small-box-footer"
                    >
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>

                <div class="col-lg-2 col-6">
                  <div class="small-box bg-info">
                    <div class="inner">
                      <h4>
                        <b>₹{resellerData ? resellerData.main_wallet : "0"}</b>
                      </h4>
                      <p>All Users Wallet Balance</p>
                    </div>
                    <div class="icon">
                      <i class="ion ion-bag"></i>
                    </div>
                    <a
                      href="/#/user/total_wallet_balance"
                      class="small-box-footer"
                    >
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>

                <div class="col-lg-2 col-6">
                  <div class="small-box bg-primary">
                    <div class="inner">
                      <h4>
                        <b>
                          ₹
                          {resellerData
                            ? resellerData.today_wallet_topup[0].total_amount
                            : "0"}
                        </b>
                      </h4>
                      <p>Today Wallet Topup</p>
                    </div>
                    <div class="icon">
                      <i class="ion ion-stats-bars"></i>
                    </div>
                    <a
                      href="/#/user/commission_payment_summary"
                      class="small-box-footer"
                    >
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>

                <div class="col-lg-2 col-6">
                  <div class="small-box bg-success">
                    <div class="inner">
                      <h4>
                        <b>
                          ₹
                          {resellerData
                            ? resellerData.today_admin_earning[0].total_amount
                            : "0"}
                        </b>
                      </h4>
                      <p>Today Admin Earning</p>
                    </div>
                    <div class="icon">
                      <i class="ion ion-stats-bars"></i>
                    </div>
                    <a
                      href="/#/user/commission_payment_summary"
                      class="small-box-footer"
                    >
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>

                {/* <div class="col-lg-2 col-6">
                <div class="small-box bg-warning">
                  <div class="inner">
                    <h4>
                      <b>
                        {data.pending_pancard_coupon
                          ? data.pending_pancard_coupon.rows.length > 0
                            ? data.pending_pancard_coupon.rows[0].total_amount +
                              " [" +
                              data.pending_pancard_coupon.count +
                              "]"
                            : "0" +
                              " [" +
                              data.pending_pancard_coupon.count +
                              "]"
                          : "0"}
                      </b>
                    </h4>
                    <p>Pending PAN Coupon</p>
                  </div>
                  <div class="icon">
                    <i class="ion ion-stats-bars"></i>
                  </div>
                  <a
                    href="/admin/uti_pancard_report?status=Pending"
                    class="small-box-footer"
                  >
                    More info <i class="fas fa-arrow-circle-right"></i>
                  </a>
                </div>
              </div> */}

                <div class="col-lg-2 col-6">
                  <div class="small-box bg-danger">
                    <div class="inner">
                      <h4>
                        <b>
                          {resellerData.pending_recharge
                            ? resellerData.pending_recharge.rows.length > 0
                              ? "₹" +
                                resellerData.pending_recharge.rows[0]
                                  .total_amount +
                                " [" +
                                resellerData.pending_recharge.count +
                                "]"
                              : "₹0" +
                                " [" +
                                resellerData.pending_recharge.count +
                                "]"
                            : "0"}
                        </b>
                      </h4>

                      <p>Pending Recharge</p>
                    </div>
                    <div class="icon">
                      <i class="ion ion-stats-bars"></i>
                    </div>
                    <a
                      href="/#/user/recharge_report?status=Pending"
                      class="small-box-footer"
                    >
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>

                <div class="col-lg-2 col-6">
                  <div class="small-box bg-warning">
                    <div class="inner">
                      <h4>
                        <b>
                          {resellerData.pending_dispute
                            ? resellerData.pending_dispute.rows.length > 0
                              ? "₹" +
                                resellerData.pending_dispute.rows[0]
                                  .total_amount +
                                " [" +
                                resellerData.pending_dispute.count +
                                "]"
                              : "0" +
                                " [" +
                                resellerData.pending_dispute.count +
                                "]"
                            : "0"}
                        </b>
                      </h4>

                      <p>Pending Dispute</p>
                    </div>
                    <div class="icon">
                      <i class="ion ion-stats-bars"></i>
                    </div>
                    <a
                      href="/#/user/dispute_recharge_report"
                      class="small-box-footer"
                    >
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>
                {/* 
              <div class="col-lg-2 col-6">
                <div class="small-box bg-secondary">
                  <div class="inner">
                    <h4>
                      <b>
                        {data.pending_fund_req
                          ? data.pending_fund_req.rows.length > 0
                            ? "₹" +
                              data.pending_fund_req.rows[0].total_amount +
                              " [" +
                              data.pending_fund_req.count +
                              "]"
                            : "0" + " [" + data.pending_fund_req.count + "]"
                          : "0"}
                      </b>
                    </h4>

                    <p>Pending Fund Request</p>
                  </div>
                  <div class="icon">
                    <i class="ion ion-stats-bars"></i>
                  </div>
                  <a
                    href="/#/user/pending_fund_request"
                    class="small-box-footer"
                  >
                    More info <i class="fas fa-arrow-circle-right"></i>
                  </a>
                </div>
              </div> */}
              </div>
            )}

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Recharge Sales Report</h5>
                  </div>

                  <div className="card-body">
                    <div class="row mt-2">
                      <div class="col-12 col-sm-6 col-md-3">
                        <div class="info-box">
                          <span class="info-box-icon bg-success elevation-1">
                            <i class="fas fa-arrow-right"></i>
                          </span>
                          <div class="info-box-content">
                            <span class="info-box-text">SUCCESS</span>
                            <span class="info-box-number">
                              {isLoading && (
                                <div class="spinner-border spinner-border-sm"></div>
                              )}
                              {!isLoading && rechargeSummaryData
                                ? rechargeSummaryData.success.rows.length > 0
                                  ? "₹" +
                                    rechargeSummaryData.success.rows[0]
                                      .total_amount +
                                    " [" +
                                    rechargeSummaryData.success.count +
                                    "]"
                                  : "₹0" +
                                    " [" +
                                    rechargeSummaryData.success.count +
                                    "]"
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3">
                        <div class="info-box mb-4">
                          <span class="info-box-icon bg-warning elevation-1">
                            <i class="fas fa-arrow-right"></i>
                          </span>
                          <div class="info-box-content">
                            <span class="info-box-text">PENDING</span>
                            <span class="info-box-number">
                              {isLoading && (
                                <div class="spinner-border spinner-border-sm"></div>
                              )}
                              {!isLoading && rechargeSummaryData
                                ? rechargeSummaryData.pending.rows.length > 0
                                  ? "₹" +
                                    rechargeSummaryData.pending.rows[0]
                                      .total_amount +
                                    " [" +
                                    rechargeSummaryData.pending.count +
                                    "]"
                                  : "₹0" +
                                    " [" +
                                    rechargeSummaryData.pending.count +
                                    "]"
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-3">
                        <div class="info-box mb-4">
                          <span class="info-box-icon bg-danger elevation-1">
                            <i class="fas fa-arrow-right"></i>
                          </span>
                          <div class="info-box-content">
                            <span class="info-box-text">FAILED</span>
                            <span class="info-box-number">
                              {isLoading && (
                                <div class="spinner-border spinner-border-sm"></div>
                              )}
                              {!isLoading && rechargeSummaryData
                                ? rechargeSummaryData.failed.rows.length > 0
                                  ? "₹" +
                                    rechargeSummaryData.failed.rows[0]
                                      .total_amount +
                                    " [" +
                                    rechargeSummaryData.failed.count +
                                    "]"
                                  : "₹0" +
                                    " [" +
                                    rechargeSummaryData.failed.count +
                                    "]"
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-3">
                        <div class="info-box mb-4">
                          <span class="info-box-icon bg-primary elevation-1">
                            <i class="fas fa-arrow-right"></i>
                          </span>
                          <div class="info-box-content">
                            <span class="info-box-text">TOTAL</span>
                            <span class="info-box-number">
                              {isLoading && (
                                <div class="spinner-border spinner-border-sm"></div>
                              )}
                              {!isLoading && rechargeSummaryData
                                ? rechargeSummaryData.total.rows.length > 0
                                  ? "₹" +
                                    rechargeSummaryData.total.rows[0]
                                      .total_amount +
                                    " [" +
                                    rechargeSummaryData.total.count +
                                    "]"
                                  : "₹0" +
                                    " [" +
                                    rechargeSummaryData.total.count +
                                    "]"
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>

      {/* <NoticeDialog
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        noticeData={noticeData}
      /> */}
    </React.Fragment>
  );
};

export default Dashboard;
